import type { FeaturePageSeo } from "@/components/feature-template/seo";
import type { FAQItem } from "@/components/feature-template/types";

// Shared by page.tsx (JSON-LD) and the client page (visible FAQ) so both always match.

export const faqs: FAQItem[] = [
  {
    question: "How does the AI mock interview work?",
    answer:
      "You choose a role, level, interview type and tech stack. The AI interviewer then speaks with you in real time, asks follow-up questions based on your answers and produces a transcript and scored feedback when you finish.",
  },
  {
    question: "Is it a voice interview or a chat?",
    answer:
      "It is a spoken interview. You answer out loud through your microphone, just as you would on a real video call.",
  },
  {
    question: "Which interview types can I practise?",
    answer:
      "Technical, Behavioral or Mixed rounds, for junior, mid-level and senior roles, with the tech stack you choose.",
  },
  {
    question: "What does the feedback include?",
    answer:
      "An overall score out of 100, scores for each category with a short comment, a final assessment, a list of strengths and specific areas to improve.",
  },
  {
    question: "Can I review what I said?",
    answer:
      "Yes. Every session saves a full transcript, so you can reread any answer alongside the feedback.",
  },
  {
    question: "Can I track my progress over time?",
    answer:
      "Your interviews page lists every session with its role, level, type and score, so you can see how your scores change as you practise.",
  },
  {
    question: "What do I need to get started?",
    answer:
      "A microphone and a quiet room. Headphones help the AI hear you clearly and keep the transcript accurate.",
  },
];

export const seo: FeaturePageSeo = {
  slug: "ai-mock-interview",
  name: "AI Mock Interview",
  title: "AI Mock Interview with Voice & Feedback | MindMyJob",
  description:
    "Practise real interviews out loud with an AI interviewer. Choose role, level and tech stack, then get a transcript, a score out of 100 and specific feedback.",
  keywords: [
    "ai mock interview",
    "mock interview practice",
    "ai interview practice online",
    "technical interview practice",
    "behavioral interview practice",
    "interview feedback ai",
    "voice interview simulator",
    "practice interview questions",
    "interview preparation tool",
    "mock interview for software engineers",
  ],
  ogImage: "/assets/images/features/ai-mock-interview/hero-live-interview.png",
  ogImageAlt: "MindMyJob AI Mock Interview live voice session with transcript",
  featureList: [
    "Live voice interviews with an AI interviewer",
    "Technical, Behavioral and Mixed rounds",
    "Junior, mid and senior levels",
    "Score out of 100 with category breakdown",
    "Strengths and areas to improve",
    "Full transcript of every session",
    "Interview history",
  ],
  faqs,
};
